import * as React from "react";
import { dispatch } from "@rematch/core";
import PrimaryCategories from "./primaryCategories";
import SecondCategories from "./secondCategories";
import SecondaryLinkage from "./secondaryLinkage";
import FormModel from "../../viewModel/formModel";

const onSelectChange = (e, field, modelName) => {
  let data = {};
  data[field] = e;

  dispatch["antDemo"].setValue({
    formInfo: data,
    model: modelName,
    field,
    value: e
  });
};

// 获取订单来源主分类组件
export const getPrimaryCategories = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <PrimaryCategories
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      data-field={formModel.field}
      secondCategories-field={formModel.extField1}
    />
  );
};

// 获取订单来源主分类组件
export const getSecondCategories = (formModel: FormModel) => {
  const onChange = (e, field) => {
    onSelectChange(e, field, formModel.modelName);
  };
  return (
    <SecondCategories
      width={formModel.width}
      value={formModel.value}
      onChange={formModel.onChange || onChange}
      modelName={formModel.modelName}
      data-field={formModel.field}
    />
  );
};

export const getOrderSource = (formModel: FormModel) => {
  
  let primaryForm = new FormModel(); 
  primaryForm = { ...formModel };
  primaryForm.width = 120;
  primaryForm.field = formModel.field;
  primaryForm.value = formModel.value;
  // 这里extField1表示二级类目字段
  primaryForm.extField1 = formModel.extField1;

  let secondForm = new FormModel();
  secondForm = { ...formModel };
  secondForm.width = 120;
  secondForm.field = formModel.extField1;
  secondForm.value = formModel.extFieldValue1;

  return <SecondaryLinkage primaryData={primaryForm} secondData={secondForm} />;
};
